// @flow

import * as React from 'react';

import { Link } from '@ta/common.routing';
import { InteractionLogger } from '@ta/tracking.interactions';
import { ResponsiveImage } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';

import styles from './ShelfCruiseSearchSection.less';

type Props = {
  /** The json cruise search info object */
  cruiseSearchInfo: any,
};

const ShelfCruiseSearchSection = (props: Props) => {
  const { cruiseSearchInfo } = props;
  const hasPhotos = cruiseSearchInfo.thumbnail;
  const cruiseSearchInfoUrl =
    cruiseSearchInfo && cruiseSearchInfo.route && cruiseSearchInfo.route.url
      ? cruiseSearchInfo.route.url
      : '#';

  return (
    <InteractionLogger>
      {logInteraction => (
        <div className={styles.section}>
          <React.Fragment>
            <Link
              href={cruiseSearchInfoUrl}
              className="ui_poi_thumbnail"
              onClick={e => logInteraction(e, 'feedClick')}
            >
              {hasPhotos ? (
                <div className={styles.photo_wrap}>
                  <div className={styles.shelfForPhoto}>
                    <ResponsiveImage
                      sources={cruiseSearchInfo.thumbnail.photoSizes}
                      width="100%"
                      height="100%"
                      borderRadius="2px"
                    />
                  </div>
                </div>
              ) : (
                <span className={styles.shelfForPhoto}>
                  {' '}
                  <div className={styles.no_photo_available}>
                    <Icon name="cruises" className={styles.icon} />
                  </div>
                </span>
              )}
            </Link>
            <Link
              href={cruiseSearchInfoUrl}
              className="item poi_name ui_link"
              onClick={e => logInteraction(e, 'feedClick')}
            >
              <span className={styles.name}>{cruiseSearchInfo.locationName}</span>
            </Link>
            {<Link href={cruiseSearchInfoUrl} onClick={e => logInteraction(e, 'feedClick')} />}
          </React.Fragment>
        </div>
      )}
    </InteractionLogger>
  );
};

export default ShelfCruiseSearchSection;
